import React from 'react';

export default function Mobile() {
  return (
    <svg width="14" height="20" viewBox="0 0 14 20">
      <path d="M13.78,2.23c.14,2.62.22,5.25.22,7.85s-.08,5.23-.22,7.75a2,2,0,0,1-1.65,1.88A38.37,38.37,0,0,1,7,20a38.66,38.66,0,0,1-5.15-.29A2,2,0,0,1,.22,17.83C.08,15.35,0,12.69,0,10S.06,4.75.22,2.23A2,2,0,0,1,1.85.35,38.75,38.75,0,0,1,7,0a38.45,38.45,0,0,1,5.13.35A2,2,0,0,1,13.78,2.23ZM7,18a1,1,0,0,0,1-1,1,1,0,0,0-1-1,1,1,0,0,0-1,1A1,1,0,0,0,7,18Zm4.82-3.31c.13-2.2.2-4,.2-5.84S11.89,5,11.71,2.6a.35.35,0,0,0-.3-.33A37.55,37.55,0,0,0,7,2a37.29,37.29,0,0,0-4.42.27.38.38,0,0,0-.33.33C2.09,4.93,2,7.1,2,9.32c0,1.74,0,3.49.15,5.37a.34.34,0,0,0,.33.31h9A.3.3,0,0,0,11.8,14.69Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Mobile/index.js